import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { PayWorkflowComponent } from './pay-workflow/pay-workflow.component';
import { AuthGuard } from '../security/auth.guard';
import { PaymentService } from './payment.service';
import { CompletePaymentComponent } from './complete-payment/complete-payment.component';
import { PaymentReceiptComponent } from './payment-receipt/payment-receipt.component';

const routes: Routes = [
  { path: 'completePayment', component: CompletePaymentComponent, canActivate: [AuthGuard]},
  ];
@NgModule({
  imports: [RouterModule.forChild(routes),
    CommonModule
  ],
  exports: [PaymentReceiptComponent],

  declarations: [PayWorkflowComponent, CompletePaymentComponent, PaymentReceiptComponent],
  providers : [PaymentService]
})
export class PaymentModule { }



// WEBPACK FOOTER //
// ./src/app/shared/payment/payment.module.ts